var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "comment-wrapper" }, [
    _c("label", { attrs: { for: _vm.name } }, [
      _vm._v(_vm._s(_vm.resource("SprintPlanning_Comments_Add_DisplayName")))
    ]),
    _vm._v(" "),
    _c("textarea", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.value,
          expression: "value"
        }
      ],
      ref: "comment",
      staticClass: "new-comment form-control",
      attrs: { name: _vm.name },
      domProps: { value: _vm.value },
      on: {
        blur: function($event) {
          return _vm.emitValue()
        },
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.value = $event.target.value
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }